import React from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  Grid,
  IconButton,
  Modal,
  //Divider,
  Box,
  Typography,

} from '@mui/material';

import {
    AmplitudesArticularesExercicio,
    DuracaoExercicio,
    Comentarios
}from '../utente/chartsExercicio'

import {
    EsforcoDorExercicios,
    TaxaRealizacaoExercicios,
    //TaxaCorrecaoCosporal,
    HarmoniaGestoExercicios
}from '../utente/chartsAtivity'
import TaxaCorrecaoCosporal from '../utente/chartsAtivity/TaxaCorrecaoCorporal';

function DashEx(props){
  
  return (props.trigger) ? (
    
    <Box className="popup">
        <Modal open={props.trigger} onClose={() => props.setTrigger(false)}>
            <Box className="popup-inner-dash" sx={{height: 700, overflow: "hidden", overflowY: "scroll",
            width: '75%',top: '50%', left: '52%', transform: 'translate(-50%, -50%)'}} >
                {/*props.ex.membros {props.ex.name} */ }
                <Typography sx={{paddingTop:1,paddingBottom:2}} variant="h5">Historial do Exercício - {props.ex.name}</Typography>

                <Grid container spacing={1}>
                    <Grid item xs={12} md={6} lg={4}>
                        <DuracaoExercicio/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <AmplitudesArticularesExercicio/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <EsforcoDorExercicios/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <HarmoniaGestoExercicios/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <TaxaRealizacaoExercicios/>
                    </Grid>

                    <Grid item xs={12} md={6} lg={4}>
                        <TaxaCorrecaoCosporal/>
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                        <Box sx={{ height: 300, overflow: "hidden", overflowY: "scroll"}}>
                            <Comentarios/>
                        </Box>
                    </Grid>
                </Grid>
                
                <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                    <CloseIcon/>
                </IconButton>
                {props.children}
            </Box>
        </Modal>
    </Box>      
  ) : "";
}
export default DashEx
